exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-tabs {\r\n    padding-top: 15px;\r\n}\r\n\r\n::-webkit-input-placeholder { /* Chrome/Opera/Safari */\r\n    color: #e5e6e7;\r\n  }\r\n  ::-moz-placeholder { /* Firefox 19+ */\r\n    color:  #e5e6e7;\r\n  }\r\n  :-ms-input-placeholder { /* IE 10+ */\r\n    color:  #e5e6e7;\r\n  }\r\n  :-moz-placeholder { /* Firefox 18- */\r\n    color:  #e5e6e7;\r\n  }\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/admin/tab.css
// module id = 982
// module chunks = 0